import React from 'react';

import css from './SectionGreenBanner.module.css';

/**
 * A thin full-width green banner section for the landing page.
 * Renders a headline and optional subtext on a green background.
 *
 * @component
 * @param {Object} props
 * @param {string} props.sectionId
 * @param {string} props.headline
 * @param {string} props.subtext
 * @returns {JSX.Element}
 */
const SectionGreenBanner = ({ sectionId, headline, subtext }) => {
  return (
    <section id={sectionId} className={css.root}>
      <div className={css.content}>
        {headline ? <p className={css.headline}>{headline}</p> : null}
        {subtext ? <p className={css.subtext}>{subtext}</p> : null}
      </div>
    </section>
  );
};

export default SectionGreenBanner;
